import React from 'react'

import { IInputProps, TEntityOverridePropType } from 'src/types'
import ObjectInput from './ObjectInput'
import BooleanInput from './BooleanInput'
import NumberInput from './NumberInput'
import ImageInput from './ImageInput'
import CoordinatesInput from './CoordinatesInput'
import ReferenceArrayInput from './arrays/ReferencedArrayInput'
import ReferencedInput from './Referenced/ReferencedInput'
import ArrayInput from './arrays'
import MapManifestInput from './MapManifestInput'
import GroupsInput from './GroupsInput'
import BaseOnInput from './BasedOnInput'
import ColorInput from './ColorInput'
import DateTimeInput from './DateTimeInput'
import CustomFileInput from './FileInput'
import EnumInput from './EnumInput'
import SoundInput from './SoundInput'
import StringInput from './StringInput'
import { JSONObjectInput } from './JSONObjectInput'
import { BirthDateInput } from './DT'

const inputs = {
  object: ObjectInput,
  enum: EnumInput,
  string: StringInput,
  number: NumberInput,
  integer: NumberInput,
  boolean: BooleanInput,
  Image: ImageInput,
  sound: SoundInput,
  Coordinate: CoordinatesInput,
  array: ArrayInput,
  MapManifest: MapManifestInput,
  groups: GroupsInput,
  color: ColorInput,
  basedOn: BaseOnInput,
  'date-time': DateTimeInput,
  'birth-date': BirthDateInput,
  file: CustomFileInput,
  JSONObject: JSONObjectInput,
  reference: {
    string: ReferencedInput,
    object: ReferencedInput,
    array: ReferenceArrayInput,
  },
} satisfies Partial<
  Record<
    Exclude<TEntityOverridePropType, 'reference'>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    React.FC<IInputProps<any>>
  >
> & {
  reference: Partial<
    Record<TEntityOverridePropType, React.FC<IInputProps<any>>>
  >
}

export default inputs
